import { Calendar, UserRound } from 'lucide-react';
import type { PublicAppointmentActionLanding } from '@/features/okdoc/types';

interface AppointmentSummaryCardProps {
  landing: PublicAppointmentActionLanding;
}

export function AppointmentSummaryCard({ landing }: AppointmentSummaryCardProps) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_24px_60px_-36px_rgba(15,23,42,0.35)]">
      <div className="border-b border-slate-100 bg-gradient-to-r from-slate-50 to-white px-5 py-4">
        <p className="text-sm text-slate-500">Пациент</p>
        <p className="mt-1 text-2xl font-semibold tracking-tight text-slate-900">
          {landing.patient_name || landing.first_name || 'Пациент'}
        </p>
      </div>

      {landing.appointment?.date_time && (
        <div className="grid gap-3 p-5 sm:grid-cols-2 sm:p-6">
          <div className="rounded-2xl border border-slate-100 bg-slate-50/80 p-4">
            <div className="mb-2 flex items-center gap-2 text-sm text-slate-500">
              <Calendar className="h-4 w-4" />
              Дата и время
            </div>
            <div className="font-semibold text-slate-900">{landing.appointment.date_time}</div>
          </div>
          <div className="rounded-2xl border border-slate-100 bg-slate-50/80 p-4">
            <div className="mb-2 flex items-center gap-2 text-sm text-slate-500">
              <UserRound className="h-4 w-4" />
              Врач
            </div>
            <div className="font-semibold text-slate-900">{landing.appointment.doctor_name || 'Уточняется'}</div>
          </div>
        </div>
      )}
    </div>
  );
}
